import React from 'react';

const isWeb = process.env.REACT_APP_MOBILE_APP !== 'true';

export const WebOnly: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return isWeb ? <>{children}</> : null;
};